<!--
 * @Description: 
 * @Date: 2020-09-22 16:58:46
-->
<template>
  <div class="search-el">
    <div>
      <van-search
        :class="[focus? 'focus' : '']"
        v-model="word"
        show-action
        placeholder="搜索内容"
        @search="onSearch"
        @cancel="onCancel"
        @focus="onFocus"
        @blur="onBlur"
        :autofocus="true"
        :clearable="false"
      ></van-search>
      <p v-show="focus" class="search-el-bt" @click="onSearch">搜索</p>
    </div>
  </div>
</template>
<script>
import { mapActions, mapState } from 'vuex';
export default {
  name: '',
  props: {},
  data() {
    return {
      word: '',
      focus: false
    };
  },
  methods: {
    ...mapActions(['searchWordActions']),
    onCancel() {
      this.$router.go(-1);
    },
    onSearch() {
      this.searchWordActions(this.word);
      this.$emit('search-input-enter', 'enter');
    },
    onFocus() {
      this.$parent.cname = 'record';
      this.focus = true;
    },
    onBlur() {
      setTimeout(() => {
        this.focus = false;
      }, 200);
    }
  },
  computed: {
    ...mapState({
      keyword: state => state.search.keyword
    })
  },
  watch: {
    keyword: {
      immediate: true,
      handler(v) {
        this.word = v;
      }
    }
  },
  components: {},
  created() {}
};
</script>
<style lang="less" scoped>
.search-el {
  position: relative;
  /deep/ .van-search {
    margin-bottom: 0.4rem;
    .van-search__action {
      color: #959599;
      font-size: 0.43rem;
    }
    .van-search__content {
      background: #f4f5fa;
      border-radius: 0.21rem;
    }
  }
  /deep/ .focus {
    .van-search__content {
      padding-top: 0.53rem;
      padding-bottom: 0.53rem;
      padding-right: 1.6rem;
    }
  }
  &-bt {
    position: absolute;
    right: 1.6rem;
    top: 50%;
    transform: translateY(-50%);
    color: #3667ec;
    font-size: 0.48rem;
    font-weight: 500;
    padding-left: 0.32rem;
    border-left: 1px solid #d8dae2;
  }
}
</style>
